/* AKTEPELER - HESAP KATMANI
 *
 * TEK AMACI: alici bir daha kafadan carpim yapmasin.
 *
 * Persona simulasyonunda 7 personanin 6'si ayni seyi soyledi:
 * "birim fiyat urun sayfasinda, kademe ana sayfada, kargo SSS'te, KDV haric -
 *  toplami ben hesapliyorum." Butik satici 250 adedin 2.648 TL oldugunu
 * bilmeden siteden cikiyordu.
 *
 * Bu dosya uc yere gercek rakam basar:
 *   1) URUN SAYFASI - 250/500/1.000 icin birim, ara toplam, KARGO ve
 *      TESLIMLI TOPLAM. Kargo agirliktan hesaplanir, tahmin degil.
 *   2) URUN KARTI   - "250 adet = X TL" tek satir.
 *   3) SEPET        - bir sonraki kademeye kac adet kaldi ve BU SEPETTE
 *      kac lira eder.
 *
 * DOKUNMADIKLARI: .aktmoq · .aktkdv · aktepeler-siparis-kurali.js ·
 * aktepeler-hareket.js. Hicbiri silinmez, yeniden yazilmaz; bu dosya EKLER.
 *
 * DURUSTLUK: butun rakamlar canli /products.json ve /cart.js verisinden
 * hesaplanir. Uydurma spec, uydurma fiyat, "yaklasik" yok.
 * KDV haric oldugu her yerde yazili.
 */
(function () {
  'use strict';

  /* Shopify'daki otomatik indirimlerle BIREBIR ayni olmali.
      4 Agu 2026'da canli sepette dogrulandi: 250->%0, 500->%5,
      1000->%10, 2500->%15. Birini degistirirsen Shopify tarafini da
      degistir; yoksa ekran bir sey gosterip odeme baska tutar tahsil eder. */
  var KADEME = [
    { adet: 500, oran: 5 },
    { adet: 1000, oran: 10 },
    { adet: 2500, oran: 15 }
  ];

  /* Agirlik bantlari - KDV haric, 29 Tem 2026'da canli sepetle dogrulandi */
  var BANT = [
    { kg: 1, ucret: 100 }, { kg: 5, ucret: 180 }, { kg: 15, ucret: 300 },
    { kg: 35, ucret: 480 }, { kg: 75, ucret: 1200 }, { kg: 150, ucret: 1900 },
    { kg: 300, ucret: 2800 }, { kg: Infinity, ucret: 4500 }
  ];

  function kargo(kg) {
    for (var i = 0; i < BANT.length; i++) if (kg <= BANT[i].kg) return BANT[i].ucret;
    return 4500;
  }

  function tl(n) {
    return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₺';
  }
  function sayi(n) {
    return n.toLocaleString('tr-TR');
  }

  /* ---------------------------------------------------------------------
     1) URUN SAYFASI - teslimli tutar tablosu
     --------------------------------------------------------------------- */
  function urunSayfasi() {
    var m = /\/products\/([^/?#]+)/.exec(window.location.pathname);
    if (!m) return;
    if (document.querySelector('[data-akt-hesap]')) return;

    fetch('/products/' + m[1] + '.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = p.variants && p.variants[0];
        if (!v) return;
        cubukKur(v.price / 100);
        siparisTablosu(p);
        yerlestirTablo(p, v);
        numuneButonu(p);
        varyantTakip(p);
      })
      .catch(function () { /* ag hatasi sayfayi bozmasin */ });
  }

  function tabloIcerik(v) {
    var birim = v.price / 100;
    var gram = v.grams || 0;

    var satirlar = KADEME.map(function (k) {
      var indirimli = birim * (100 - k.oran) / 100;
      var mal = indirimli * k.adet;
      var kg = gram * k.adet / 1000;
      var kg_ucret = gram ? kargo(kg) : null;
      var teslimli = kg_ucret === null ? null : mal + kg_ucret;
      var teslimliBirim = teslimli === null ? null : teslimli / k.adet;

      return '<tr>' +
        '<th>' + sayi(k.adet) + ' adet</th>' +
        '<td class="akt-h__oran">%' + k.oran + '</td>' +
        '<td>' + tl(indirimli) + '</td>' +
        '<td>' + tl(mal) + '</td>' +
        '<td>' + (kg_ucret === null ? '—' :
          '<span class="akt-h__kg">' + kg.toLocaleString('tr-TR', { maximumFractionDigits: 1 }) + ' kg</span> ' + tl(kg_ucret)) + '</td>' +
        '<td class="akt-h__son">' + (teslimli === null ? '—' : tl(teslimli)) +
        (teslimliBirim === null ? '' : '<span class="akt-h__br">' + tl(teslimliBirim) + '/adet</span>') +
        '</td></tr>';
    }).join('');

    return '' +
      '<div class="akt-h" data-akt-hesap>' +
      '<div class="akt-h__bas">Toptan tutar <span>KDV hariç</span></div>' +
      '<div class="akt-h__kaydir"><table class="akt-h__t"><thead><tr>' +
      '<th>Adet</th><th>İndirim</th><th>Birim</th><th>Ürün</th><th>Kargo</th><th>Teslimli toplam</th>' +
      '</tr></thead><tbody>' + satirlar + '</tbody></table></div>' +
      '<p class="akt-h__not"><b>Kademe eşiği sepetin toplam adedine bakar, ürün ayrımı yapmaz.</b> ' +
      '250 telefon standı + 250 anı küpü = 500 adet demektir ve ikisine birden %5 uygulanır. ' +
      'Ayrı ayrı sipariş verseydiniz hiçbirinde indirim olmazdı.</p>' +
      '<p class="akt-h__not akt-h__not--ince">Kargo ağırlığa göre hesaplandı, ödeme adımında kesinleşir. ' +
      'Numune için adet 1 yazın; bedeli ilk toptan siparişinizden düşülür.</p>' +
      '</div>';
  }

  function yerlestirTablo(p, v) {
    var hedef =
      document.querySelector('.product-information') ||
      document.querySelector('.product__info') ||
      document.querySelector('[class*="product-details"]') ||
      document.querySelector('main');
    if (!hedef) return;

    var kutu = document.createElement('div');
    kutu.innerHTML = tabloIcerik(v);
    var el = kutu.firstChild;

    /* Sepete ekle blogunun hemen ALTINA - alici once fiyati gorup sonra karar veriyor */
    var buton = hedef.querySelector('[name="add"], .product-form__buttons, product-form-buttons');
    var kap = buton ? (buton.closest('product-form-buttons, .product-form__buttons, form') || buton) : null;
    if (kap && kap.parentNode) kap.parentNode.insertBefore(el, kap.nextSibling);
    else hedef.appendChild(el);
  }

  /* Varyant degisince tabloyu tazele - fiyat ve gramaj varyanta bagli */
  function varyantTakip(p) {
    var son = null;
    function tazele() {
      var id = new URLSearchParams(window.location.search).get('variant');
      var v = null;
      if (id) v = p.variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) v = p.variants[0];
      if (!v || v.id === son) return;
      son = v.id;
      var eski = document.querySelector('[data-akt-hesap]');
      if (!eski) return;
      var yeni = document.createElement('div');
      yeni.innerHTML = tabloIcerik(v);
      eski.replaceWith(yeni.firstChild);
    }
    window.addEventListener('popstate', tazele);
    document.addEventListener('variant:update', tazele);
    document.addEventListener('change', function (e) {
      if (e.target && /variant|option/i.test(e.target.name || '')) setTimeout(tazele, 120);
    }, true);
  }

  /* ---------------------------------------------------------------------
     1b) KADEME CUBUGU - adet kutusuna bagli, CANLI
     Kullanicinin istedigi mekanik: adet arttikca dolan cubuk ve
     "su kadar daha ekle, su indirim" mesaji.
     Cubuk urun sayfasinda adet kutusunu dinler; sepette /cart.js'i.
     --------------------------------------------------------------------- */
  function cubukHtml(adet, birim) {
    var simdiki = 0, sonraki = null;
    KADEME.forEach(function (k) { if (adet >= k.adet) simdiki = k.oran; });
    for (var i = 0; i < KADEME.length; i++) {
      if (adet < KADEME[i].adet) { sonraki = KADEME[i]; break; }
    }

    /* Dolum: son esige (1.000) gore oranla, ama esikler esit araliklarla
       yerlesir - gorsel olarak adil bir merdiven cikar. */
    var son = KADEME[KADEME.length - 1].adet;
    var oran = Math.min(100, adet / son * 100);

    var isaret = KADEME.map(function (k) {
      var sol = k.adet / son * 100;
      var aktif = adet >= k.adet;
      return '<span class="akt-c__im' + (aktif ? ' akt-c__im--on' : '') + '"' +
             ' style="left:' + sol + '%">' +
             '<b>%' + k.oran + '</b><i>' + sayi(k.adet) + '</i></span>';
    }).join('');

    var mesaj;
    if (adet < 1) {
      mesaj = 'Adet girin.';
    } else if (adet === 1) {
      mesaj = '<b>1 adet numune.</b> Bedeli ilk toptan siparişinizden düşülür.';
    } else if (sonraki) {
      var kalan = sonraki.adet - adet;
      var kazanc = birim * adet * (sonraki.oran - simdiki) / 100;
      mesaj = '<b>' + sayi(kalan) + ' adet</b> daha ekleyin, ' +
              '<b>%' + sonraki.oran + '</b> kademesine geçin. ' +
              'Bu siparişte <b class="akt-c__kazanc">' + tl(kazanc) + '</b> kazanç.';
    } else {
      mesaj = 'En yüksek kademedesiniz: <b>%15</b>.';
    }

    return '<div class="akt-c" data-akt-cubuk>' +
      '<div class="akt-c__ust">' +
        '<span class="akt-c__adet">' + (adet > 0 ? sayi(adet) + ' adet' : '—') + '</span>' +
        '<span class="akt-c__oran">' + (simdiki ? '%' + simdiki + ' indirim uygulanıyor'
                                                : 'henüz indirim yok') + '</span>' +
      '</div>' +
      '<div class="akt-c__ray"><div class="akt-c__dolu" style="width:' + oran + '%"></div>' +
        isaret + '</div>' +
      '<p class="akt-c__mesaj">' + mesaj + '</p>' +
      '</div>';
  }

  function cubukKur(birim) {
    var giris = document.querySelector('form[action*="/cart/add"] input[name="quantity"]')
             || document.querySelector('input[name="quantity"]');
    if (!giris) return;

    var kap = document.createElement('div');
    kap.innerHTML = cubukHtml(parseInt(giris.value, 10) || 0, birim);
    var el = kap.firstChild;

    var form = giris.closest('form[action*="/cart/add"]') || giris.closest('form');
    var yer = form || giris.parentNode;
    if (yer && yer.parentNode) yer.parentNode.insertBefore(el, yer);
    else return;

    function tazele() {
      var v = parseInt(giris.value, 10) || 0;
      var y = document.createElement('div');
      y.innerHTML = cubukHtml(v, birim);
      var eski = document.querySelector('[data-akt-cubuk]');
      if (eski) eski.replaceWith(y.firstChild);
    }
    giris.addEventListener('input', tazele);
    giris.addEventListener('change', tazele);
    /* Horizon'un +/- dugmeleri degeri programatik yaziyor: tiklamadan sonra oku */
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[class*="quantity"]')) setTimeout(tazele, 90);
    }, true);
  }

  /* ---------------------------------------------------------------------
     1e) KARISIK ADET SIPARIS TABLOSU  (cerceveal mekanigi)
     Referans sayfada her olcu bir satir, her satirin kendi adet kutusu ve
     altta canli toplam var. B2B'de dogrusu bu: alici tek tek varyant secip
     alt alta sepete eklemiyor, tabloda karisik adet giriyor.

     Bizde ek olarak: kademe eşiği SEPETIN TOPLAMINA baktigi icin tablodaki
     satirlarin toplami dogrudan indirim kademesini belirliyor.
     --------------------------------------------------------------------- */
  function siparisTablosu(p) {
    if (!p.variants || p.variants.length < 2) return;      /* tek varyantta gereksiz */
    if (document.querySelector('[data-akt-tablo]')) return;

    var satir = p.variants.map(function (v, n) {
      return '<tr data-akt-satir data-vid="' + v.id + '" data-fiyat="' + (v.price / 100) +
        '" data-gram="' + (v.grams || 0) + '">' +
        '<th>' + (v.title || ('Seçenek ' + (n + 1))) + '</th>' +
        '<td class="akt-t__f">' + tl(v.price / 100) + '</td>' +
        '<td class="akt-t__a"><span class="akt-t__step">' +
        '<button type="button" data-akt-eksi aria-label="Azalt">−</button>' +
        '<input type="text" inputmode="numeric" value="0"' +
        ' aria-label="' + (v.title || '') + ' adedi" data-akt-adet>' +
        '<button type="button" data-akt-arti aria-label="Artır">+</button>' +
        '</span></td>' +
        '<td class="akt-t__ara">—</td>' +
        (v.available ? '' : '<td class="akt-t__yok">tükendi</td>') +
        '</tr>';
    }).join('');

    var el = document.createElement('div');
    el.className = 'akt-t';
    el.setAttribute('data-akt-tablo', '1');
    el.innerHTML =
      '<div class="akt-t__bas">Karışık adet siparişi <span>KDV hariç</span></div>' +
      '<div class="akt-t__kaydir"><table><thead><tr>' +
      '<th>Ölçü / seçenek</th><th>Birim</th><th>Adet</th><th>Tutar</th>' +
      '</tr></thead><tbody>' + satir + '</tbody></table></div>' +
      '<div class="akt-t__alt">' +
        '<div class="akt-t__toplam"><span>Toplam</span>' +
        '<b data-akt-tadet>0 adet</b><b data-akt-ttutar>' + tl(0) + '</b></div>' +
        '<button type="button" class="akt-t__ekle" data-akt-tekle disabled>Seçilenleri sepete ekle</button>' +
      '</div>' +
      '<p class="akt-t__not">Aynı üründen farklı ölçüleri tek siparişte birleştirebilirsiniz. ' +
      'Minimum 250 adet, 250’şer artar; kademe eşiği <b>satırların toplamına</b> bakar.</p>';

    var form = document.querySelector('form[action*="/cart/add"]');
    if (form && form.parentNode) form.parentNode.insertBefore(el, form);
    else return;

    /* Kademe cubugu tablonun ALTINA tasinir - alici once adetleri girer,
       sonra hangi kademede oldugunu gorur. Ustte dururken bos cubuga
       bakiyordu. */
    var cubuk = document.querySelector('[data-akt-cubuk]');
    if (cubuk && el.parentNode) el.parentNode.insertBefore(cubuk, el.nextSibling);

    /* Tablo eski kontrollerin YERINE gecer.
       GIZLEME CSS ILE DEGIL, BURADA YAPILIR. Sebep: CSS ile
       <product-form-component> gizlenince tablo da onunla gitti ve sayfada
       satin alinacak hicbir sey kalmadi (4 Agu 2026, canlida yasandi).
       Ayrica onbellekteki eski bir CSS surumu yine ayni hatayi yapabilir;
       satir ici stil hem kesin hem geri alinabilir.
       Yalniz KONTROLLER gizlenir, kapsayicilara dokunulmaz. */
    var gizle = document.querySelectorAll(
      'variant-picker, variant-picker-component, [class*="variant-picker"],' +
      'quantity-selector-component, product-form-buttons, .product-form__buttons'
    );
    for (var g = 0; g < gizle.length; g++) {
      if (gizle[g].contains(el)) continue;              /* tabloyu iceren hicbir sey gizlenmez */
      gizle[g].style.setProperty('display', 'none', 'important');
    }
    /* Onbellekte kalmis eski CSS bu sinifla gizleme yapiyordu - temizle */
    document.documentElement.classList.remove('akt-tablo-var');
    /* Tablonun atalarini zorla gorunur tut */
    var a = el.parentElement, adim = 0;
    while (a && adim < 6) {
      a.style.setProperty('display', '', '');
      if (getComputedStyle(a).display === 'none') a.style.setProperty('display', 'block', 'important');
      a = a.parentElement; adim++;
    }

    el.addEventListener('input', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-akt-adet')) tabloTazele(el);
    });
    el.addEventListener('change', function (e) {
      if (!e.target.hasAttribute || !e.target.hasAttribute('data-akt-adet')) return;
      var v = parseInt(e.target.value, 10) || 0;
      /* satir kurali: 0 serbest (almiyorum), gerisi 250'ser */
      /* 0 = almiyorum · 1 = numune · gerisi 250'ser */
      if (v > 1 && v % 250 !== 0) e.target.value = Math.max(250, Math.round(v / 250) * 250);
      tabloTazele(el);
    });

    /* Satir +/- : 0 -> 250 -> 500 ... ve geri. 250'den asagi 1 (numune), sonra 0. */
    el.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-akt-arti],[data-akt-eksi]');
      if (!b) return;
      var i = b.parentNode.querySelector('[data-akt-adet]');
      if (!i) return;
      var v = parseInt(i.value, 10) || 0;
      var y;
      if (b.hasAttribute('data-akt-arti')) {
        y = v < 250 ? 250 : Math.floor(v / 250) * 250 + 250;
      } else {
        if (v > 250) y = Math.ceil(v / 250) * 250 - 250;
        else if (v > 1) y = 1;          /* numune */
        else y = 0;                     /* bu olcuden almiyorum */
      }
      i.value = y;
      tabloTazele(el);
    });

    el.querySelector('[data-akt-tekle]').addEventListener('click', function () {
      var b = this;
      var kalem = [];
      el.querySelectorAll('[data-akt-satir]').forEach(function (s) {
        var q = parseInt(s.querySelector('[data-akt-adet]').value, 10) || 0;
        if (q > 0) kalem.push({ id: parseInt(s.dataset.vid, 10), quantity: q });
      });
      if (!kalem.length) return;
      b.disabled = true; b.textContent = 'Ekleniyor…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: kalem })
      }).then(function () { window.location.href = '/cart'; })
        .catch(function () { b.disabled = false; b.textContent = 'Seçilenleri sepete ekle'; });
    });

    tabloTazele(el);
  }

  function tabloTazele(el) {
    var adet = 0, tutar = 0;
    el.querySelectorAll('[data-akt-satir]').forEach(function (s) {
      var q = parseInt(s.querySelector('[data-akt-adet]').value, 10) || 0;
      var f = parseFloat(s.dataset.fiyat) || 0;
      adet += q;
      tutar += q * f;
      s.querySelector('.akt-t__ara').textContent = q > 0 ? tl(q * f) : '—';
      s.classList.toggle('akt-t__satir--on', q > 0);
    });

    var oran = 0;
    KADEME.forEach(function (k) { if (adet >= k.adet) oran = k.oran; });
    var indirimli = tutar * (100 - oran) / 100;

    el.querySelector('[data-akt-tadet]').textContent = sayi(adet) + ' adet' +
      (oran ? ' · %' + oran : '');
    el.querySelector('[data-akt-ttutar]').textContent = tl(indirimli);
    el.querySelector('[data-akt-tekle]').disabled = adet < 1;

    /* Kademe cubugu varsa onu da bu toplamla besle */
    var c = document.querySelector('[data-akt-cubuk]');
    if (c && adet > 0) {
      var y = document.createElement('div');
      y.innerHTML = cubukHtml(adet, adet ? tutar / adet : 0);
      c.replaceWith(y.firstChild);
    }
  }

  /* ---------------------------------------------------------------------
     1d) NUMUNE ICIN ILETISIM - WhatsApp
     --------------------------------------------------------------------- */
  function numuneButonu(p) {
    if (document.querySelector('[data-akt-numune]')) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form || !form.parentNode) return;

    var metin = encodeURIComponent(
      'Merhaba, ' + (p && p.title ? p.title.split('|')[0].trim() : 'ürününüz') +
      ' için numune istiyorum.');
    var a = document.createElement('a');
    a.className = 'akt-numune';
    a.setAttribute('data-akt-numune', '1');
    a.href = 'https://wa.me/905510521211?text=' + metin;
    a.target = '_blank';
    a.rel = 'noopener';
    a.innerHTML = '<b>Numune için iletişime geçin</b>' +
      '<span>1 adet, liste fiyatından · bedeli ilk toptan siparişinizden düşülür</span>';
    form.parentNode.insertBefore(a, form.nextSibling);
  }

  /* ---------------------------------------------------------------------
     2) URUN KARTI - "250 adet = X TL"
     --------------------------------------------------------------------- */
  var ANAHTAR = 'akt-fiyat-v2';

  function kartlar() {
    var kart = document.querySelectorAll('.product-grid .card, .product-card, .card-wrapper');
    if (!kart.length) return;

    var c = null;
    try { c = JSON.parse(sessionStorage.getItem(ANAHTAR) || 'null'); } catch (e) {}
    if (c) return kartBas(c);

    fetch('/products.json?limit=50', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var h = {};
        (d.products || []).forEach(function (p) {
          var v = p.variants && p.variants[0];
          if (v) h[p.handle] = { fiyat: parseFloat(v.price), gram: v.grams || 0 };
        });
        try { sessionStorage.setItem(ANAHTAR, JSON.stringify(h)); } catch (e) {}
        kartBas(h);
      })
      .catch(function () {});
  }

  function kartBas(h) {
    document.querySelectorAll('.product-grid .card, .product-card, .card-wrapper').forEach(function (k) {
      if (k.dataset.aktToplam) return;
      var a = k.querySelector('a[href*="/products/"]');
      if (!a) return;
      var m = /\/products\/([^/?#]+)/.exec(a.getAttribute('href') || '');
      if (!m || !h[m[1]]) return;

      var d = h[m[1]];
      var mal = d.fiyat * 250;                        /* 250 adet = liste fiyati */

      /* 27.10.2026: ok/sayi merdiveni mobilde anlasilmiyordu ve karti uzatiyordu
         (kullanici). Kartta iki kisa satir: MOQ + toplam, en derin kademenin birimi.
         Tam merdiven urun sayfasindaki tabloda. En derin kademe KADEME'den gelir. */
      var son = KADEME[KADEME.length - 1];

      var s = document.createElement('p');
      s.className = 'akt-kart-toplam';
      s.innerHTML = '<span class="akt-kt__satir">Min. 250 adet: <b>' + tl(mal) + '</b></span>' +
        '<span class="akt-kt__satir akt-kt__ind">' + sayi(son.adet) + '+ adette birimi <b>' +
        tl(d.fiyat * (100 - son.oran) / 100) + '</b></span>';

      var yer = k.querySelector('.aktmoq');           /* MOQ rozetinin altina */
      if (yer && yer.parentNode) yer.parentNode.insertBefore(s, yer.nextSibling);
      else {
        var b = k.querySelector('.card-information, .product-card__content, .card__content');
        if (b) b.appendChild(s); else return;
      }
      /* Kart basligi: SEO basligi ("... Toptan | Ham Kayin") dar kartta 4 satira
         tasiyordu. Kartta yalniz urun adi; tam baslik title ozniteliginde kalir. */
      k.querySelectorAll('h3, .text-block:not(product-price) *').forEach(function (bas) {
        if (bas.children.length) return;
        var tam = bas.textContent.trim();
        if (tam.indexOf(' | ') < 0) return;
        var kisa = tam.split(' | ')[0].replace(/\s+Toptan$/, '');
        if (kisa) { bas.textContent = kisa; bas.title = tam; }
      });
      k.dataset.aktToplam = '1';
    });
  }

  /* ---------------------------------------------------------------------
     3) SEPET - bir sonraki kademeye ne kaldi, BU SEPETTE kac lira eder
     --------------------------------------------------------------------- */
  function sepet() {
    if (!/\/cart(\/|$|\?)/.test(window.location.pathname + window.location.search)) return;

    fetch('/cart.js?t=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        /* Bos sepet: denetimde "toptan kurallarini hic gostermiyor" cikti.
           Alici bos sepete geldiginde MOQ, kademe ve KDV notunu gormeli;
           yoksa geri donup urun sayfasinda aramak zorunda kaliyor. */
        if (!c.item_count) return bosSepet();
        var adet = c.item_count;
        var ham = (c.original_total_price != null ? c.original_total_price : c.items_subtotal_price) / 100;

        var simdiki = 0, sonraki = null;
        KADEME.forEach(function (k) { if (adet >= k.adet) simdiki = k.oran; });
        for (var i = 0; i < KADEME.length; i++) {
          if (adet < KADEME[i].adet) { sonraki = KADEME[i]; break; }
        }

        var kg = (c.total_weight || 0) / 1000;
        var kg_ucret = kargo(kg);

        var html = '<div class="akt-h akt-h--sepet" data-akt-sepet>' +
          '<div class="akt-h__bas">Sepet özeti <span>KDV hariç</span></div>' +
          '<div class="akt-h__satir"><span>Sepetteki toplam adet</span><b>' + sayi(adet) + '</b></div>' +
          '<div class="akt-h__satir"><span>Uygulanan kademe</span><b>' +
            (simdiki ? '%' + simdiki : 'henüz yok') + '</b></div>' +
          '<div class="akt-h__satir"><span>Ağırlık ve kargo</span><b>' +
            kg.toLocaleString('tr-TR', { maximumFractionDigits: 1 }) + ' kg · ' + tl(kg_ucret) + '</b></div>';

        if (sonraki) {
          var kalan = sonraki.adet - adet;
          var kazanc = ham * (sonraki.oran - simdiki) / 100;
          html += '<p class="akt-h__firsat"><b>' + sayi(kalan) + ' adet</b> daha eklerseniz sepetin tamamı ' +
            '<b>%' + sonraki.oran + '</b> kademesine geçer. Bu sepette <b>' + tl(kazanc) + '</b> eder. ' +
            'İlave adedi aynı üründen ya da farklı bir üründen tamamlayabilirsiniz.</p>';
        } else {
          html += '<p class="akt-h__firsat">En yüksek kademedesiniz: <b>%15</b>.</p>';
        }
        html += '</div>';

        var hedef = document.querySelector('.cart__footer, .cart-items, main');
        if (!hedef) return;
        var eski = document.querySelector('[data-akt-sepet]');
        if (eski) eski.remove();
        var kutu = document.createElement('div');
        kutu.innerHTML = html;
        hedef.insertBefore(kutu.firstChild, hedef.firstChild);
      })
      .catch(function () {});
  }

  /* Bos sepette toptan kurallarini goster - alici geri donup aramasin */
  function bosSepet() {
    if (document.querySelector('[data-akt-sepet]')) return;
    var hedef = document.querySelector('.cart__footer, .cart-items, main');
    if (!hedef) return;

    var basamak = KADEME.map(function (k) {
      return '<div class="akt-h__basamak"><span>' + sayi(k.adet) + ' adet ve üzeri</span>' +
             '<b>%' + k.oran + '</b></div>';
    }).join('');

    var kutu = document.createElement('div');
    kutu.innerHTML =
      '<div class="akt-h akt-h--sepet" data-akt-sepet>' +
      '<div class="akt-h__bas">Toptan koşulları <span>KDV hariç</span></div>' +
      '<div class="akt-h__satir"><span>Minimum sipariş</span><b>250 adet</b></div>' +
      '<div class="akt-h__satir"><span>Adet artışı</span><b>250’şer</b></div>' +
      '<div class="akt-h__satir"><span>Numune</span><b>1 adet</b></div>' +
      '<div class="akt-h__merdiven">' + basamak + '</div>' +
      '<p class="akt-h__firsat">Kademe eşiği <b>sepetin toplam adedine</b> bakar, ürün ' +
      'ayrımı yapmaz: 250 telefon standı + 250 anı küpü = 500 adet demektir ve ikisine ' +
      'birden %5 uygulanır.</p>' +
      '<p class="akt-h__not akt-h__not--ince">Fiyatlar KDV hariçtir. Kargo ağırlığa göre ' +
      'hesaplanır. Numune bedeli ilk toptan siparişinizden düşülür.</p>' +
      '</div>';
    hedef.insertBefore(kutu.firstChild, hedef.firstChild);
  }

  /* ---------------------------------------------------------------------- */
  function kur() { urunSayfasi(); kartlar(); sepet(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kur, { once: true });
  } else { kur(); }

  document.addEventListener('cart:updated', sepet);
  document.addEventListener('cart:refresh', sepet);
})();
